import { useState, useCallback } from 'react';
import styles from './index.less';

function initActiveState(condition) {
  return condition.reduce((res, item) => {
    res[item.key] = '';
    return res;
  }, {});
}
function SelectCondition(props = {}) {
  const { condition = [], initActiveState = {} } = props;
  const [isDrawerShow, setIsDrawerShow] = useState(false);
  const [activeState, setActiveState] = useState(initActiveState);
  const conditionSection = (conditionSelf) => {
    const handleClick = (target) => {
      const _target = activeState[conditionSelf.key] === target ? '' : target;
      setActiveState((activeState) => {
        return { ...activeState, [conditionSelf.key]: _target };
      });
    };
    const isActive = (target) => {
      const activeConditon = activeState[conditionSelf.key];
      return target === activeConditon;
    };
    return (
      <>
        <div className={styles.title}>{conditionSelf.label}</div>
        <div className={styles.conditionButton}>
          {conditionSelf.value.map((item) => (
            <div
              className={`${styles.button} ${isActive(item) ? styles.active : ''}`}
              onClick={() => handleClick(item)}
            >
              {item}
            </div>
          ))}
        </div>
      </>
    );
  };
  const conditionList = props.condition.map((item) => {
    return conditionSection(item);
  });
  const toggleVisible = () => {
    setIsDrawerShow((isDrawerShow) => !isDrawerShow);
  };
  const reset = () => {
    setActiveState((activeState) => {
      return Object.keys(activeState).reduce((state, key) => {
        state[key] = '';
        return state;
      }, {});
    });
  };
  const handleCancel = () => {
    toggleVisible();
    setActiveState(initActiveState);
  };
  const handleConfirm = () => {
    toggleVisible();
    props.onConfirm(activeState);
  };
  return (
    <div className={styles.selectCondition}>
      <div className={styles.selectBox}>
        <div className={styles.selectBtn} onClick={toggleVisible}>
          筛选 <img className={styles.arrow} src={require('images/bottomArrow.png')} />{' '}
          <div className={styles.leftJiao}></div>
          <div className={styles.rightJiao}></div>
        </div>
      </div>
      {isDrawerShow && (
        <div className={styles.drawer}>
          <div className={styles.content}>{conditionList}</div>
          <div className={styles.buttonList}>
            <div className={styles.button} onClick={handleCancel}>
              取消
            </div>
            <div className={styles.line}></div>
            <div className={styles.button} onClick={reset}>
              重置
            </div>
            <div className={`${styles.button} ${styles.confirm}`} onClick={handleConfirm}>
              确定
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SelectCondition;
